/**
 * UI Color constants
 * Centralized color definitions for consistent theming
 */

// Inactive/disabled state colors
export const INACTIVE_COLOR = '#b4bcca';
export const INACTIVE_HOVER_COLOR = '#969fae';
